<template>
  <!-- TODO: Traiter surTitre,titre et sousTitre -->
  <div
    :class="jel_getClassObject(content)"
    class="d-flex flex-column imgPleineLargeur text-align-center p-0"
  >
    <div class="cursor-pointer pt-2" @click="jel_forcerClickHyperlien(refRedirection)">
      <b-link :ref="refRedirection" v-bind="jel_getLienBinding(content.lien)" class="d-none">
        <!-- conserver pour accessibilité -->
        invisible</b-link
      >
      <!-- TODO: Erreur d'accessibilité. Un inline element ne peut contenir un block element -->
      <b-img-lazy
        :src="jel_getFichierSrc(content.image)"
        :alt="content.altImage"
        class="w-100 imgExplorer px-2"
      />
      <p class="texte titreJeu" v-html="content.titre"></p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MediaImageExplorer',
  props: { content: { type: Object, required: true } },
  data() {
    return {
      refRedirection: this._uid,
    };
  },
};
</script>

<style lang="scss" scoped>
.imgPleineLargeur {
  background-color: $couleur-primaire;
  padding: 1rem;
  margin-bottom: 10px;
  border-radius: 6px;
}

.titreJeu {
  text-align: center;
  letter-spacing: 0px;
  color: $couleur-blanc;
  opacity: 1;
}
.imgExplorer {
  height: 6rem;
}

a:hover {
  text-decoration: none;
}
</style>
